import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useIdleTimer } from "react-idle-timer";
import { Configuration } from "../../../environment/setup";
import ConfirmationPopup from "./confirmationPopup";
import { connect } from "react-redux";
import { logout } from "../../../redux/thunks/userProfileThunk";
import Auth from "../../../utils/auth";

const IdleTimeoutPopup: React.FC = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [remaining, setRemaining] = useState<number>(
    Configuration.UserIdleTime
  );

  const ACTION_GO_HOME = "go-home";

  const logout = () => {
    if (Auth.isLoggedIn()) {
      console.log("Idle Timer: Logging out", props);
      props.logout();
    }
  };

  const goHome = () => {
    if (location.pathname !== "/") navigate("/");
  };

  const broadcastGoHome = () => {
    idleTimer.message({ action: ACTION_GO_HOME }, true);
  };

  const onMessage = (message: any) => {
    console.log("Idle Timer: onMessage", message);
    switch (message.action) {
      case ACTION_GO_HOME:
        setShowConfirm(false);
        goHome();
        break;
    }
  };

  const onActive = (event) => {
    if (showConfirm) setShowConfirm(false);
  };

  const onIdle = () => {
    console.log("Idle Timer: onIdle", idleTimer, idleTimer.isLeader());
    if (idleTimer.isLeader() && Auth.isLoggedIn()) {
      logout();
      broadcastGoHome();
    }
  };

  const onPrompt = () => {
    console.log("Idle Timer: onPrompt", props, idleTimer.isLeader());
    if (!Auth.isLoggedIn()) return;

    setShowConfirm(true);
  };

  const onPromptConfirmed = (logoutChosen: boolean) => {
    console.log("Idle Timer: onPromptConfirmed", logoutChosen);
    if (logoutChosen) {
      logout();
      broadcastGoHome();
    } else {
      idleTimer.activate();
    }
  };

  const idleTimer = useIdleTimer({
    crossTab: true,
    timeout: Configuration.UserIdleTime,
    name: "idle-logout",
    events: [
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
    ],
    onIdle: onIdle,
    onPrompt: onPrompt,
    onMessage: onMessage,
    onActive: onActive,
    leaderElection: true,
    promptBeforeIdle: Configuration.UserIdleTimePrompt,
    debounce: 300,
    syncTimers: 300,
  });

  //Handles the countdown timer on the logout prompt
  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(idleTimer.getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      {showConfirm && (
        <ConfirmationPopup
          title={"Log out confirmation"}
          confirmAction={onPromptConfirmed}
          hideActionButton={true}
          message={
            <>
              You have been idle for an extended period of time. Click{" "}
              {"'Cancel'"} if you would like to stay logged in.
              <br />
              <br />
              You will be automatically logged out in <b>{remaining}</b> seconds
              if you you do not cancel.
            </>
          }
          buttonText={"Logout"}
        />
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    logout: (token: string) => {
      dispatch(logout());
    },
  };
};

export default connect(null, mapDispatchToProps)(IdleTimeoutPopup);
